module.exports = __webpack_public_path__ + "img/504.69b70de6.png";